import React, { useRef, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

import closeIcon from '../../../../Assets/close-icon.svg';
import { serviceConsumer } from '../../../../network/ServiceConsumer';
import { handlePhotoUpload } from '../../../../helper/handleUploads';
import AddButton from '../../../AddButton/AddButton';
import Loader from '../../../Loader/Loader';
import { ShowToastMessage } from '../../../../helper/ShowToastMessage';
import CustomInput from '../CustomInput';
import JudgeRegionField from '../JudgeRegionField';

const NewCollaboratorModal = ({ setOpenCollabModal, openNewCollabModal, setOpenNewCollabModal, getCollab, from }) => {
    const [imgError, setImgErr] = useState('');
    const [logo, setLogo] = useState('');
    const [upl, setUpl] = useState('');
    const [loading, setLoading] = useState(false);
    const imgInputRef = useRef(null);
    let EventID = localStorage.getItem('ID');
    // Every adjudicator gets a Feis.link account (card 930d3ac0): a new one is
    // added with first name, last name and the email their invitation goes to.
    const isAdjudicator = openNewCollabModal === "adjudicator";

    const handleLOgo = () => {
        imgInputRef.current.click();
    };

    //Initial values for formik
    const newCollabInitialValues = {
        name: '',
        fname: '',
        lname: '',
        email: '',
        location: '',
        region: '',
        type: openNewCollabModal,//mention the modalname
        photo: '',
    };

    const newCollabValidationSchema = Yup.object().shape({
        ...(isAdjudicator
            ? {
                fname: Yup.string().trim().required('This field is required.').max(50),
                lname: Yup.string().trim().required('This field is required.').max(50),
                email: Yup.string().trim().email('Enter a valid email address.').required('This field is required.'),
                // a new judge isn't in the CLRG directory: admin sets the region
                // (the place shown comes from it, so no Location box)
                region: Yup.string().required('Choose a region.'),
            }
            : {
                name: Yup.string()
                    .trim()
                    .label('First Name:')
                    .required('This field is required.')
                    .nullable()
                    .max(50),
            }),
        ...(isAdjudicator ? {} : {
            location: Yup.string()
                .trim()
                .label('Last Name:')
                .required('This field is required.')
                .nullable()
                .max(50),
        }),
    });

    const handleFileSelect = async (event) => {
        handlePhotoUpload(event, setLoading, setLogo, setUpl, setImgErr);
    };

    const addCollab = async (values, formikHelpers) => {
        const payload = {
            ...(isAdjudicator
                ? { fname: values.fname, lname: values.lname, email: values.email.trim(), region: values.region }
                : { name: values.name, location: values.location }),
            type: values.type,
            photo: logo,
            eventId: EventID,
        };
        try {
            setLoading(true);
            const type = from === "grade" ? "grade-exam" : "people"
            const url = `${process.env.REACT_APP_BASE_URL}/${type}/${openNewCollabModal}`;///people/musician,/grade-exam/examiner
            const response = await serviceConsumer('POST', url, payload);
            if (isAdjudicator && response?.inviteError) ShowToastMessage("error", `Added, but the invitation wasn't sent: ${response.inviteError}`);
            else if (isAdjudicator && response?.success) ShowToastMessage("success", "Added, and the account invitation is on its way.");
            setOpenNewCollabModal("");
            setOpenCollabModal("")
            getCollab();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            ShowToastMessage("error", error?.messages || "Something went wrong");
        }
    };

    const closeModalHandler = () => {
        console.log(openNewCollabModal)
        //close this modal and open previous modal->select collaborator
        if (openNewCollabModal !== "sponsor") {
            setOpenCollabModal(openNewCollabModal);
            setOpenNewCollabModal("")
        } else {
            setOpenNewCollabModal("")
            setOpenCollabModal("")
        }

    }

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <>
            {loading && <Loader />}
            <Modal className="addDancerScroll" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }} open={true}>
                <Box>
                    <div style={{ maxHeight: '100vh', padding: '5px 100vw', overflow: 'scroll', }}>
                        <div className="main-div-add-adj">
                            <div className="close-div mt-4 mb-1">
                                <img src={closeIcon} alt="close-icon" className="close-icon" onClick={closeModalHandler} />
                            </div>
                            <p className="color-subtitle text-center mb-4" style={{ marginTop: '40px' }}>{`Add ${capitalizeFirstLetter(openNewCollabModal)}`}</p>
                            <div className="d-flex align-items-center justify-content-center" style={{ background: 'white,borderRadius: 14px;' }}>
                                <Formik
                                    initialValues={newCollabInitialValues}
                                    validationSchema={newCollabValidationSchema}
                                    onSubmit={addCollab}
                                >
                                    {(formik) => (
                                        <Form className="form form-label-right" autoComplete="off">
                                            {isAdjudicator ? <>
                                                <CustomInput label="First name" name="fname" type="text" placeholder="First Name" formik={formik} />
                                                <CustomInput label="Last name" name="lname" type="text" placeholder="Last Name" formik={formik} />
                                            </> : <CustomInput label="Full name" name="name" type="text" placeholder="Name" formik={formik} />}

                                            {isAdjudicator
                                                ? <JudgeRegionField formik={formik} />
                                                : <CustomInput label="Location" name="location" type="text" placeholder="Location" formik={formik} />}
                                            {isAdjudicator && <>
                                                <CustomInput label="Email" name="email" type="email" placeholder="name@example.com" formik={formik} />
                                                <span style={{ maxWidth: "290px", fontSize: "12px", color: "#797979", marginTop: "-6px", marginBottom: "10px" }}>
                                                    We'll email them an invitation to set up their Feis.link adjudicator account.
                                                </span>
                                            </>}

                                            <input type="file" ref={imgInputRef} style={{ display: 'none' }} onChange={handleFileSelect} />

                                            <div className="d-grid">
                                                <label className="label-head-org" style={{ marginLeft: '1px' }} >Photo:</label>
                                                <div>
                                                    <AddButton onClick={handleLOgo} className="plusIconbtn mt-0">Add Photo</AddButton>
                                                </div>
                                                {imgError && (<span className="error mt-2" style={{ width: '248px' }}>{imgError}</span>)}
                                                {upl && <span className="auth-suc">{upl}</span>}
                                            </div>
                                            <div className="mb-5 d-flex justify-content-center">
                                                <button className={formik.isValid && formik.dirty ? 'updateChange' : 'updateChangeDisabled'}
                                                    style={{ fontWeight: '500', height: '42px', padding: '9px 11px', }}
                                                    type="submit"
                                                    disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                                                >
                                                    {`Add ${openNewCollabModal}`}
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
};


export default NewCollaboratorModal